function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M11.5 7C12.875 7 14 5.875 14 4.5S12.875 2 11.5 2A2.507 2.507 0 009 4.5C9 5.875 10.125 7 11.5 7zM11.5 9.5A2.507 2.507 0 009 12c0 1.375 1.125 2.5 2.5 2.5S14 13.375 14 12s-1.125-2.5-2.5-2.5zM11.5 17A2.507 2.507 0 009 19.5c0 1.375 1.125 2.5 2.5 2.5s2.5-1.125 2.5-2.5-1.125-2.5-2.5-2.5z",
  strokeWidth: 1.5,
  strokeLinecap: "round"
});

var SvgMore = function SvgMore(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 4,
    height: 14,
    viewBox: "8 6 7 12",
    fill: "none",
    stroke: "#6D7C8F"
  }, props), _ref);
};

export default SvgMore;